import React from "react";
import PipelineCandidate from "./PipelineCandidate/PipelineCandidate";
import { NewTab, PageTab } from "../../../components";
import { useModuleAccess } from "../../../hooks";

const PipelineCandidates = () => {
  const pipelineMenus = [
    {
      title: "Pipeline Candidates",
      page: <PipelineCandidate />,
      type: "main",
      id: "pipelinecandidates_pipelinecandidates",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: pipelineMenus,
    parentId: "pipelinecandidates",
  });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="pipeline-candidates"
    />
  );
};

export default PipelineCandidates;
